<template>
    <div :class="{ 'ly-is-full': isFull }">
        <div class="tableSelect" ref="tableSelect" v-if="showSearchBar && searchBar.searchColums.length > 0">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item :label="sitem.label + ':'" v-for="(sitem, sindex) in searchBar.searchColums">
                    <el-input v-if="sitem.type === 'input'" size="default" v-model="formInline[sitem.prop]"
                        :maxlength="sitem.maxlength" clearable :placeholder="sitem.placeholder" @change="search"
                        :style="{ width: (sitem.width ? sitem.width : 200) + 'px' }"></el-input>
                    <el-select v-else-if="sitem.type === 'select'" size="default" v-model="formInline[sitem.prop]"
                        :placeholder="sitem.placeholder" clearable filterable
                        :style="{ width: (sitem.width ? sitem.width : 200) + 'px' }" @change="search">
                        <el-option v-if="sitem.options" v-for="option in sitem.options" :key="option.value"
                            :label="option.label" :value="option.value">
                        </el-option>
                    </el-select>
                    <el-date-picker v-else-if="sitem.type === 'datepicker-datetimerange'" style="width: 350px"
                        v-model="timers" type="datetimerange" @change="timeChange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <slot name="searchBar"></slot>
                <el-form-item label="">
                    <el-button @click="handleSearchClick('search')" type="primary" icon="Search"
                        v-show="rowHandle.permission.search">查询</el-button>
                </el-form-item>
                <el-form-item label="">
                    <el-button @click="handleSearchClick('reset')" icon="Refresh">重置</el-button>
                </el-form-item>
                <!--                <el-form-item label=""><el-button  @click="addAdmin" type="primary" v-show="isShowBtn('userManage','用户管理','Create')">新增</el-button></el-form-item>-->
                <!--                <el-form-item label=""><el-button  @click="exportDataBackend" type="primary">导出</el-button></el-form-item>-->
            </el-form>
        </div>

        <div class="table">
            <!-- 表格头部操作栏 -->
            <div class="tableToolBar" ref="tableToolBar">
                <!-- 左侧按钮栏目 -->
                <div>
                    <div>
                        <el-button @click="handleEdit('', 'add')" type="primary" icon="Plus"
                            v-show="rowHandle.permission.add">新增</el-button>
                        <el-button @click="handleMutiDelete" type="danger" icon="Delete" :disabled="multiple"
                            v-if="showSelectable && rowHandle.permission.del">删除</el-button>
                        <slot name="tablebar-l"></slot>
                    </div>
                </div>
                <div>
                    <slot name="tablebar-c"></slot>
                </div>
                <div>
                    <slot name="tablebar-r"></slot>
                    <!-- 右侧表头筛选 -->
                    <!--                    <div class="transfer">-->
                    <!--                        <el-button icon="Refresh" circle @click="handleRefresh"></el-button>-->
                    <!--                        <el-button icon="Search" circle type="primary" @click="showSearchBar=showSearchBar?false:true"></el-button>-->
                    <!--                        <el-button icon="Filter" @click="drawer=true" circle type="success"></el-button>-->
                    <!--                        <el-drawer v-model="drawer" direction="rtl" title="显示/隐藏列" size="20%">-->
                    <!--                            <el-checkbox :indeterminate="drawerIndeterminate" @change="handleDrawerCheckAllChange">全选 {{ "("+drawerCheckedValue.length+"/"+tableColumns.length+")"}}</el-checkbox>-->
                    <!--                            <el-checkbox-group v-model="drawerCheckedValue" @change="handleDrawerColumnsChange" style="overflow: auto;display: flex;flex-direction: column">-->
                    <!--                                <el-checkbox  v-for="ckitem in tableColumns" :key="ckitem.prop" :label="ckitem.label" :checked="!ckitem.hidden"></el-checkbox>-->
                    <!--                            </el-checkbox-group>-->

                    <!--                        </el-drawer>-->
                    <!--                    </div>-->
                    <div class="transfer">
                        <el-button type="primary" link @click="handleRefresh">
                            <el-icon size="20px">
                                <Refresh />
                            </el-icon>
                        </el-button>
                        <el-popover placement="bottom" trigger="click" :width="100">
                            <el-checkbox :indeterminate="drawerIndeterminate" @change="handleDrawerCheckAllChange">全选 {{ "("
                                + drawerCheckedValue.length + "/" + tableColumns.length + ")" }}
                            </el-checkbox>
                            <el-divider style="margin: 5px auto"></el-divider>
                            <el-checkbox-group v-model="drawerCheckedValue" @change="handleDrawerColumnsChange"
                                style="overflow: auto; display: flex; flex-direction: column">
                                <el-checkbox v-for="ckitem in tableColumns" :key="ckitem.prop" :label="ckitem.label"
                                    :checked="!ckitem.hidden"></el-checkbox>
                            </el-checkbox-group>
                            <template #reference>
                                <el-button link type="primary">
                                    <el-icon size="20px">
                                        <Setting />
                                    </el-icon>
                                </el-button>
                            </template>
                        </el-popover>
                        <el-button link type="primary" @click="showSearchBar = !showSearchBar">
                            <el-icon size="20px">
                                <Search />
                            </el-icon>
                        </el-button>
                        <el-button type="primary" link @click="setFull">
                            <el-icon size="20px">
                                <FullScreen />
                            </el-icon>
                        </el-button>
                    </div>
                </div>
            </div>
            <el-table v-bind="tableOptions" :height="tableHeight" :data="tableData" ref="tableref" v-loading="loadingPage"
                :row-key="rowKey" style="width: 100%" @selection-change="handleSelectionChange">
                <!-- 选择框列/序号列是否开启 -->
                <el-table-column type="selection" width="55" align="center" v-if="showSelectable"></el-table-column>
                <el-table-column type="index" width="60" align="center" label="序号" v-if="showSequence">
                    <template #default="scope">
                        <span v-text="getTableIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <!-- 普通列 -->
                <template v-for="(column, columnIndex) in tableColumns" :key="columnIndex">
                    <span v-if="column.slot">
                        <slot :name="column.slot" :tit="columnIndex"></slot>
                    </span>
                    <el-table-column :prop="column.prop" :label="column.label" :sortable="column.sortable"
                        :min-width="column.minWidth" :show-overflow-tooltip="true" v-if="column.hidden !== undefined && column.slot == undefined
                            ? !column.hidden
                            : true
                            ">
                        <template #default="{ row, $index }">
                            <template v-if="!column.render">
                                <span>{{ column.prop == 'email_host_password' || column.prop == 'license_pwd' ?
                                    '***********'
                                    : row[column.prop] || "-"
                                }}</span>
                            </template>


                            <template v-else>
                                <div v-if="column.prop == 'wxacodeunlimit'" @click="checkImage(row.company)">
                                    <ly-render :render="column.render" :row="row" :index="$index" :column="column">
                                    </ly-render>
                                </div>
                                <div class="" v-else>
                                    <ly-render :render="column.render" :row="row" :index="$index" :column="column">
                                    </ly-render>
                                </div>
                            </template>
                        </template>
                    </el-table-column>
                </template>
                <!-- 操作列 -->
                <el-table-column label="操作" :fixed="rowHandle.fixed" :width="rowHandle.width">
                    <template #header>
                        <div style="display: flex; justify-content: space-between; align-items: center">
                            <div>操作</div>
                            <!--                            <div @click="setFull">-->
                            <!--                                <el-tooltip content="全屏" placement="bottom">-->
                            <!--                                    <el-icon ><full-screen /></el-icon>-->
                            <!--                                </el-tooltip>-->
                            <!--                            </div>-->
                        </div>
                    </template>

                    <template #default="scope">
                        <span class="table-operate-btn" @click="handleEdit(scope.row, 'detail')"
                            v-show="rowHandle.permission.detail">详情</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row, 'edit')"
                            v-show="rowHandle.permission.edit">编辑</span>
                        <span class="table-operate-btn" @click="handleEdit(scope.row, 'del')"
                            v-show="rowHandle.permission.del">删除</span>

                        <!-- 自定义操作按钮 -->
                        <slot name="customHandle" :row="scope.row"></slot>
                    </template>
                </el-table-column>
                <!-- 自定义空数据 -->
                <template v-slot:empty>
                    <el-empty :image-size="150" description="暂无数据" />
                </template>
            </el-table>
        </div>
        <!-- 分页 -->
        <Pagination v-bind:child-msg="pageparm" :page-options="pageparams" @callFather="callFather" v-if="showPagination">
        </Pagination>
        <!-- 弹窗 -->
        <ly-dialog v-model="isDialogShow" :title="dialogTitle" :width="formOptions.width ? formOptions.width : '50%'"
            :before-close="handleDialogClose">
            <el-form :model="formData" :rules="rules" ref="rulesForm" label-width="auto" :disabled="formDisabled">
                <el-row :gutter="formOptions.gutter ? formOptions.gutter : 20">
                    <el-col :span="fitem.form.span ? fitem.form.span : 24" v-for="(fitem, findex) in formColumns">
                        <el-form-item :label="fitem.label + '：'" :prop="fitem.prop" v-if="fitem.form.hidden !== undefined && dialogTitle !== '详情'
                            ? !fitem.form.hidden
                            : true
                            ">
                            <el-input :disabled="isFormItemEditDisabled(fitem.form.editDisabled)"
                                v-if="fitem.type == 'input'"
                                :show-password="fitem.form.showPassword ? fitem.form.showPassword : false"
                                v-model="formData[fitem.prop]" clearable
                                :placeholder="fitem.form.placeholder ? fitem.form.placeholder : ''"
                                @change="fitem.form.valueChange"></el-input>
                            <el-input :disabled="isFormItemEditDisabled(fitem.form.editDisabled)" type="password"
                                v-if="fitem.type == 'password'"
                                :show-password="fitem.form.showPassword ? fitem.form.showPassword : false"
                                v-model="formData[fitem.prop]" clearable
                                :placeholder="fitem.form.placeholder ? fitem.form.placeholder : ''"
                                @change="fitem.form.valueChange"></el-input>
                            <el-date-picker style="width: 100%;" v-else-if="fitem.type == 'date'"
                                :disabled="isFormItemEditDisabled(fitem.form.editDisabled)" v-model="formData[fitem.prop]"
                                type="date" :placeholder="!!fitem.placeholder ? fitem.placeholder : '选择日期'"
                                format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
                            <el-date-picker style="width: 100%;" v-else-if="fitem.type == 'datetime'"
                                :disabled="isFormItemEditDisabled(fitem.form.editDisabled)" v-model="formData[fitem.prop]"
                                type="datetime" :placeholder="!!fitem.placeholder ? fitem.placeholder : '选择日期时间'"
                                format="YYYY-MM-DD h:m:s" value-format="YYYY-MM-DD h:m:s" />

                            <el-input v-else-if="fitem.type == 'textarea'" type="textarea" v-model="formData[fitem.prop]"
                                :placeholder="fitem.form.placeholder ? fitem.form.placeholder : ''"
                                @change="fitem.form.valueChange"></el-input>
                            <el-input-number v-else-if="fitem.type == 'number'" v-model="formData[fitem.prop]" :min="0"
                                :max="999999" @change="fitem.form.valueChange"></el-input-number>
                            <el-input-number v-else-if="fitem.type == 'price'" v-model="formData[fitem.prop]" :precision="2"
                                :step="0.1" @change="fitem.form.valueChange"></el-input-number>
                            <el-switch v-else-if="fitem.type == 'switch'" v-model="formData[fitem.prop]"
                                active-color="#13ce66" inactive-color="#ff4949"
                                @change="fitem.form.valueChange"></el-switch>
                            <el-select v-else-if="fitem.type === 'select'" v-model="formData[fitem.prop]"
                                :placeholder="fitem.placeholder" clearable filterable @change="fitem.form.valueChange"
                                style="width: 100%">
                                <el-option v-if="fitem.form.options" v-for="option in fitem.form.options"
                                    :key="option.value" :label="option.label" :value="option.value">
                                </el-option>
                            </el-select>
                            <el-radio-group v-else-if="fitem.type == 'radio'" v-model="formData[fitem.prop]"
                                @change="fitem.form.valueChange">
                                <el-radio :label="rditem.value" v-for="(rditem, rdindex) in fitem.form.options">{{
                                    rditem.label }}</el-radio>
                            </el-radio-group>
                            <!-- <div v-else-if="fitem.type == 'checkbox'">
                                {{formData[fitem.prop]}}
                                {{fitem.form.options}}
                            </div> -->
                            <el-checkbox-group v-else-if="fitem.type == 'checkbox'" v-model="formData[fitem.prop]"
                                @change="fitem.form.valueChange">
                                <el-checkbox v-if="fitem.form.options" v-for="option in fitem.form.options"
                                    :label="option.label" />
                            </el-checkbox-group>
                            <ly-upload-avatar v-else-if="fitem.type == 'image-avatar'" v-model="formData[fitem.prop]"
                                :width="fitem.form.width ? fitem.form.width + 'px' : '80px'"
                                :height="fitem.form.height ? fitem.form.height + 'px' : '80px'"></ly-upload-avatar>
                            <ly-upload-goods v-else-if="fitem.type == 'image-goods'"
                                v-model="formData[fitem.prop]"></ly-upload-goods>
                            <t-editor v-else-if="fitem.type == 'tinymce'" v-model="formData[fitem.prop]"></t-editor>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 自定义form部分 -->
                <slot name="formExtend" :formData="formData"></slot>
            </el-form>
            <template v-slot:footer>
                <el-button type="success" @click="updatePic(formData)">
                    更新二维码</el-button>
                <el-button @click="handleDialogClose">
                    取消</el-button>
                <el-button @click="submitData" type="primary" :loading="loadingSave" :disabled="formDisabled">确定</el-button>
                <!-- 自定义dialog底部按钮 -->
                <slot name="customDialogHandle"></slot>
            </template>
        </ly-dialog>
    </div>
</template>

<script>

//ly-crud需要的组件/方法
import { dateFormats, getTableHeight } from "@/utils/util";
import Pagination from "@/components/pagination/pagination";
import LyRender from "./render/render";
import LyDialog from "./dialog/dialog";
import LyUploadAvatar from "./upload/avatar";
import TEditor from "./TEditor";
import LyUploadGoods from "./upload/goods";
import {
    authorization_updatePic,
} from "@/api/api";
import { url } from '@/api/url';
export default {
    
    components: {
        LyUploadGoods,
        TEditor,
        LyUploadAvatar,
        LyDialog,
        LyRender,
        Pagination
    },
    name: "LyCrud",
    data() {
        return {
            showButton: false,
            isFull: false,
            loadingPage: false,
            tableHeight: 500,
            formInline: {
                page: 1,
                limit: 10
            },
            pageparm: {
                page: 1,
                limit: 10,
                total: 0
            },
            defaultImg: require("../assets/img/avatar.jpg"),
            statusList: [
                { id: 1, name: "是" },
                { id: 0, name: "否" }
            ],
            identityList: [
                { id: 0, name: "普通用户" },
                { id: 1, name: "会员" }
            ],
            tableData: [],
            timers: [],
            drawer: false,
            drawerIndeterminate: true,
            drawerCheckedValue: [],
            // 选项框选中数组
            ids: [],
            // 选项框非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            showSearchBar: true,
            //弹窗
            isDialogShow: false,
            dialogTitle: "",
            formData: {},
            rules: {},
            formColumns: [],
            loadingSave: false,
            formDisabled: false
        };
    },
    props: {
        eq_type_list: {
            type: Array,
            default: () => {
                return [];
            }
        },
        // 表头配置
        tableColumns: {
            type: Array,
            default: () => {
                return [];
            }
        },
        //是否显示分页
        showPagination: {
            type: Boolean,
            default: true
        },
        //分页参数
        pageparams: {
            type: Object,
            default: () => {
                return {
                    limit: 10,
                    pageSizes: [10, 20, 30, 40, 50, 100],
                    layout: "total, sizes, prev, pager, next, jumper"
                };
            }
        },
        // 是否显示复选框
        showSelectable: {
            type: Boolean,
            default: false
        },
        // 是否显示序号列
        showSequence: {
            type: Boolean,
            default: true
        },
        // 行唯一值
        rowKey: {
            type: String,
            default: "id"
        },
        //操作列属性
        rowHandle: {
            type: Object,
            default: () => {
                return {
                    width: 180, //操作列宽度
                    fixed: false, //类型：string/boolean	true false / 'left' / 'right',默认不固定
                    permission: {
                        add: true,
                        del: true,
                        edit: true,
                        search: true,
                        detail: true
                    }
                };
            }
        },
        //增删改查httpq请求方法
        crudRequest: {
            type: Object,
            default: () => {
                return {
                    add: Function,
                    del: Function,
                    edit: Function,
                    search: Function
                };
            }
        },
        //搜索栏目配置
        searchBar: {
            type: Object,
            default: () => {
                return {
                    showSearchBar: true, //是否显示搜索栏目
                    searchColums: []
                };
            }
        },
        //dialog表单
        formOptions: {
            type: Object,
            default: () => {
                return {
                    width: "560px", //dialog弹窗宽度：类型：百分比或字符串
                    gutter: 20 // Layout布局栅格间隔
                };
            }
        },
        //表格属性
        tableOptions: {
            type: Object,
            default: () => {
                return {
                    stripe: false, // 斑马纹
                    highlightCurrentRow: false, // 是否要高亮当前行
                    border: true, // 是否有纵向边框
                    fit: true, // 列的宽度是否自撑开
                    size: "default", // Table 的尺寸
                    lazy: false, // 是否需要懒加载
                    showHeader: true, //是否显示表头
                    defaultExpandAll: false //是否默认展开所有行
                };
            }
        }
    },
    watch: {
        pageparams(newValue, oldValue) {
            this.pageparm.limit = newValue.limit
                ? newValue.limit
                : this.pageparm.limit;
        },
        searchBar(newValue, oldValue) {
            this.showSearchBar = newValue.showSearchBar;
        },
        showSearchBar(newValue, oldValue) {
            this.$nextTick(() => {
                this.getTheTableHeight();
            });
        }
    },
    created() {
        this.showSearchBar = this.searchBar.showSearchBar;
        this.pageparm.limit = this.pageparams.limit
            ? this.pageparams.limit
            : this.pageparm.limit;
        this.formInline.limit = this.pageparm.limit;
        this.formColumns = this.tableColumns.filter(item => {
            if (item.form !== undefined) {
                return true;
            } else {
                return false;
            }
        });
        this.rules = {};
        this.formColumns.forEach(item => {
            if (item.form.rules !== undefined) {
                this.rules[item.prop] = item.form.rules;
            }
        });
        this.getData();
    },
    methods: {
        async updatePic(row) {
            console.log(row.authorization_code);
            let res = await authorization_updatePic({ 'SN': row.authorization_code })
            console.log(res);
            if (res == 200) {
                this.$message.success('更新成功')
            } else {
                this.$message.error('出现异常', res)
            }
        },
        downloadImage(name) {
            // 获取 .el-image-viewer__canvas 内的 img 元素
            const imgElement = document.querySelector('.el-image-viewer__canvas img');

            if (!imgElement) {
                console.error("Image element not found!");
                return;
            }
            console.log(name);
            const imgsrc = imgElement.src;
            // const name = imgElement.alt || 'photo'; // 设置默认图片名称为 'photo' 或使用 img 的 alt 属性

            let image = new Image();
            // 解决跨域 Canvas 污染问题
            console.log(imgsrc);
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
                let canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                let context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                let url = canvas.toDataURL("image/png"); // 得到图片的 base64 编码数据
                let a = document.createElement("a"); // 生成一个 a 元素
                let event = new MouseEvent("click"); // 创建一个单击事件
                a.download = name; // 设置图片名称
                a.href = url; // 将生成的 URL 设置为 a.href 属性
                a.dispatchEvent(event); // 触发 a 的单击事件
            };
            image.src = imgsrc;
        },
        checkImage(name) {
            console.log('点击事件', name);
            this.$nextTick(() => {
                let imageViewerActions = document.querySelector('.el-image-viewer__actions__inner');
                if (imageViewerActions && !imageViewerActions.querySelector('.el-icon-download')) {
                    let downloadIcon = document.createElement('i');
                    console.log('downloadIcon:', downloadIcon);
                    downloadIcon.className = 'el-icon';
                    downloadIcon.style.cursor = 'pointer';
                    // 添加 SVG 内容
                    const svgContent = `
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-85016e46="">
                <path fill="currentColor" d="M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64zm384-253.696 236.288-236.352 45.248 45.248L508.8 704 192 387.2l45.248-45.248L480 584.704V128h64v450.304z"></path>
            </svg>
        `;
                    downloadIcon.innerHTML = svgContent;
                    downloadIcon.onclick = () => this.downloadImage(name);
                    imageViewerActions.appendChild(downloadIcon);
                }
            });
        },
        /* <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-85016e46=""><path fill="currentColor" d="M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64zm384-253.696 236.288-236.352 45.248 45.248L508.8 704 192 387.2l45.248-45.248L480 584.704V128h64v450.304z"></path></svg> */
        //判断单个组件编辑时是否禁用disabled参数为bool值
        isFormItemEditDisabled(disabled) {
            return disabled !== undefined && this.dialogTitle === "编辑"
                ? disabled
                : false;
        },
        // 表格序列号（递增，翻页不重置）
        getTableIndex($index) {
            // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
            return (this.pageparm.page - 1) * this.pageparm.limit + $index + 1;
        },
        setFull() {
            this.isFull = !this.isFull;
            window.dispatchEvent(new Event("resize"));
        },
        //多选项框被选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.single = selection.length !== 1;
            this.multiple = !selection.length;
        },
        /** 批量删除按钮操作 */
        handleMutiDelete() {
            const ids = this.ids;
            let vm = this;
            vm.$confirm("是否确认删除选中的数据项?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function () {
                return vm.crudRequest.del({ id: ids }).then(res => {
                    if (res.code == 2000) {
                        vm.ids = [];
                        vm.single = true;
                        vm.multiple = false;
                        vm.$message.success(res.msg);
                        vm.handleRefresh();
                    } else {
                        vm.$message.warning(res.msg);
                    }
                });
            });
        },
        handleDrawerColumnsChange(val) {
            const newColumns = this.tableColumns.map(item => {
                let newitem = item;
                if (this.drawerCheckedValue.includes(item.label)) {
                    newitem.hidden = false;
                } else {
                    newitem.hidden = true;
                }
                return newitem;
            });
            this.$emit("update:tableColumns", newColumns);
        },
        handleDrawerCheckAllChange(val) {
            this.drawerCheckedValue = val
                ? this.tableColumns.map(item => item.label)
                : [];
            const newColumns = this.tableColumns.map(item => {
                let newitem = item;
                if (val) {
                    newitem.hidden = false;
                } else {
                    newitem.hidden = true;
                }
                return newitem;
            });
            this.$emit("update:tableColumns", newColumns);
            this.drawerIndeterminate = false;
        },
        //searchBar点击事件
        handleSearchClick(flag) {
            if (flag == "search") {
                this.search();
            } else if (flag == "reset") {
                this.formInline = {
                    page: 1,
                    limit: this.pageparm.limit
                };
                this.timers = [];
                this.getData();
            }
        },
        handleRefresh() {
            this.getData();
        },
        handleEdit(row, flag) {
            let vm = this;
            if (flag == "del") {
                vm.$confirm("您确定要删除该条数据吗？", {
                    closeOnClickModal: false
                })
                    .then(res => {
                        vm.crudRequest.del({ id: row.id }).then(res => {
                            if (res.code == 2000) {
                                vm.$message.success(res.msg);
                                vm.handleRefresh();
                            } else {
                                vm.$message.warning(res.msg);
                            }
                        });
                    })
                    .catch(() => { });
            } else if (flag == "detail") {
                this.dialogTitle = "详情";
                this.formDisabled = true;
                this.tableColumns.forEach(item => {
                    this.formData[item.prop] = row[item.prop];
                });
                this.isDialogShow = true;
            } else if (flag == "add") {
                this.dialogTitle = "添加";
                //默认值处理
                this.formColumns.forEach(item => {
                    if (item.form.defaultValue !== undefined) {
                        this.formData[item.prop] = item.form.defaultValue;
                    }
                    if (item.prop === "password" && item.form.rules !== undefined) {
                        this.rules.password = item.form.rules;
                    }
                });
                this.isDialogShow = true;
            } else if (flag == "edit") {
                this.dialogTitle = "编辑";
                this.formColumns.forEach(item => {
                    this.formData[item.prop] = row[item.prop];
                    if (item.prop === "password") {
                        delete this.rules.password;
                    }
                });
                this.isDialogShow = true;
            }
        },
        handleDialogClose() {
            this.isDialogShow = false;
            this.loadingSave = false;
            this.formData = {};
            this.formDisabled = false;
        },
        submitData() {
            this.$refs["rulesForm"].validate(obj => {
                if (obj) {
                    this.loadingSave = true;
                    let param = {
                        ...this.formData
                    };
                    console.log('param',param.eq_type);

                    // eqTypeOptions 数组形式
                    console.log('this.eq_type_list', this.eq_type_list);
                    let eqTypeOptions = this.eq_type_list

                    // 如果 eq_type 为空或未定义，默认选中所有选项
                    if (!param.eq_type || param.eq_type.length == 0) {
                        param.eq_type = eqTypeOptions.map(option => option.value);
                    }

                    let updatedValues = [];
                    param.eq_type.forEach(value => {
                        let matchedOption = eqTypeOptions.find(option => option.value == value);
                        console.log('value',value);
                        console.log('matchedOption',matchedOption);
                        if (matchedOption) {
                            console.log('matchedOption.device',matchedOption.device.split(","));
                            updatedValues = updatedValues.concat(matchedOption.device.split(","));
                        }
                    });
                    console.log(updatedValues);
                    param.eq_type = updatedValues.join(",");

                    if (this.dialogTitle == "编辑") {
                        this.crudRequest.edit(param).then(res => {
                            this.loadingSave = false;
                            if (res.code == 2000) {
                                this.$message.success(res.msg);
                                this.handleDialogClose();
                                this.handleRefresh();
                            } else {
                                this.$message.warning(res.msg);
                            }
                        });
                    } else {
                        this.crudRequest.add(param).then(res => {
                            this.loadingSave = false;
                            if (res.code == 2000) {
                                this.$message.success(res.msg);
                                this.handleDialogClose();
                                this.search();
                            } else {
                                this.$message.warning(res.msg);
                            }
                        });
                    }
                }
            });
            this.loadingSave = false;
        },


        /**
         * 从URL里下载文件
         */
        // 下载文件
        downloadFileURL(url) {
            var iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = url;
            document.body.appendChild(iframe);
        },
        exportDataBackend() {
            var params = {
                page: 1,
                limit: 9999
            };
            // UsersUsersExportexecl(params).then(res => {
            //      if(res.code ==2000) {
            //          this.downloadFileURL(res.data.data)
            //          //this.$message.warning(res.data.data)
            //      }
            //  })
        },
        callFather(parm) {
            this.formInline.page = parm.page;
            this.formInline.limit = parm.limit;
            this.pageparm.page = parm.page;
            this.pageparm.limit = parm.limit;
            this.getData();
        },
        search() {
            this.formInline.page = 1;
            this.formInline.limit = this.pageparm.limit;
            this.getData();
        },
        //获取列表
        async getData() {
            this.loadingPage = true;

            this.crudRequest.search(this.formInline).then(res => {
                this.loadingPage = false;
                if (res.code == 2000) {
                    this.tableData = res.data.data;

                    /* // eqTypeMapping 数组形式
                    const eqTypeOptions = [
                        { id: 1, name: "ANL_8260", device: "ANL_8260,ANL_8260_HART,ANL_8260_485,ANL_8260HB" },
                        { id: 2, name: "ANL_9107", device: "ANL_9107,ANL_9107HT" },
                        { id: 3, name: "ANL_9127", device: "ANL_9127,ANL_9127HT,ANL_9127HT_485,ANL_9127_485" },
                        { id: 4, name: "AIW_4110", device: "AIW_4110" },
                        { id: 5, name: "AIW_4111", device: "AIW_4111,AIW_4111_SOLID,AIW_4111B" },
                        { id: 6, name: "ANL_8010", device: "ANL_8010,ANL_8010_485" },
                        { id: 7, name: "ANL_9080", device: "ANL_9080,ANL_9080_485,ANL_9080_4W" },
                        { id: 8, name: "AIW_4112", device: "AIW_4112" },
                        { id: 9, name: "AIW_4117", device: "AIW_4117" },
                        { id: 10, name: "AIW_4120", device: "AIW_4120_485,AIW_4120_LTE,AIW_4120_HART,AIW_4120_LTE_485,AIW_4120,AIW_4120_IOLINK,AIW_4120_LTE_IOLINK" },
                        { id: 11, name: "AIW_3648", device: "AIW_3648,AIW_3648_485" }
                    ]; */
                    console.log('this.eq_type_list', this.eq_type_list);
                    let eqTypeOptions = this.eq_type_list

                    // 动态生成 eqTypeMapping
                    const eqTypeMapping = {};
                    eqTypeOptions.forEach(option => {
                        const devices = option.device.split(",");
                        devices.forEach(device => {
                            eqTypeMapping[device] = option.name;
                        });
                    });

                    // 处理 tableData 数据
                    this.tableData.forEach(e => {
                        if (e.eq_type.length > 0) {
                            let eqTypes = e.eq_type.split(",");
                            let uniqueEqTypes = new Set();

                            eqTypes.forEach(type => {
                                let mappedType = eqTypeMapping[type] || type;
                                uniqueEqTypes.add(mappedType);
                            });

                            e.eq_type = Array.from(uniqueEqTypes);
                        } else {
                            e.eq_type = [];
                        }
                    });
                    console.log('this.tableData', this.tableData);

                    this.pageparm.page = res.data.page;
                    this.pageparm.limit = res.data.limit;
                    this.pageparm.total = res.data.total;
                }
            });
        },


        timeChange(val) {
            if (val) {
                this.formInline.beginAt = dateFormats(val[0], "yyyy-MM-dd hh:mm:ss");
                this.formInline.endAt = dateFormats(val[1], "yyyy-MM-dd hh:mm:ss");
            } else {
                this.formInline.beginAt = null;
                this.formInline.endAt = null;
            }
            this.search();
        },
        // 计算搜索栏的高度
        listenResize() {
            this.$nextTick(() => {
                this.getTheTableHeight();
            });
        },
        getTheTableHeight() {
            let searchBarHeight =
                this.$refs.tableSelect != undefined &&
                    this.$refs.tableSelect.offsetHeight
                    ? this.$refs.tableSelect.offsetHeight
                    : 0;
            const tableToolbarHeight =
                this.$refs.tableToolBar != undefined &&
                    this.$refs.tableToolBar.offsetHeight
                    ? this.$refs.tableToolBar.offsetHeight
                    : 0;
            searchBarHeight = this.isFull ? searchBarHeight - 110 : searchBarHeight;
            this.tableHeight = getTableHeight(searchBarHeight + tableToolbarHeight);
        }
    },
    //解决table 表格缩放错位问题
    handleResize() {
        this.$nextTick(() => {
            this.$refs.tableref.doLayout();
        });
    },
    mounted() {
        //解决table 表格缩放错位问题
        window.addEventListener("resize", this.handleResize);
        // 监听页面宽度变化搜索框的高度
        window.addEventListener("resize", this.listenResize);
        this.$nextTick(() => {
            this.getTheTableHeight();
        });
    },

    unmounted() {
        //解决table 表格缩放错位问题
        window.removeEventListener("resize", this.handleResize);
        // 页面销毁，去掉监听事件
        window.removeEventListener("resize", this.listenResize);
    }
};
</script>

<style lang="scss" scoped>
.tableToolBar {
    margin-left: 1px;
    margin-right: 1px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    background: var(--el-bg-color);
    padding: 10px;
    box-shadow: 0 0 4px #cccccc;
}
</style> 
